import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import SecurityProxy from './SecurityProxy'

class SecurityService extends ServiceBase {
  postCapitalEarningLeverage(params) {
    return this.getData(() => SecurityProxy.postCapitalEarningLeverage(params))
  }
  downloadCapitalEarningLeverage(params) {
    return this.getFileDownload(() =>
      SecurityProxy.downloadCapitalEarningLeverage(params),
    )
  }
  postFundingLiquidity(params) {
    return this.getData(() => SecurityProxy.postFundingLiquidity(params))
  }
  downloadFundingLiquidity(params) {
    return this.getFileDownload(() =>
      SecurityProxy.downloadFundingLiquidity(params),
    )
  }
}

export default new SecurityService()
